import { render, staticRenderFns } from "./QueryDeskComponent.vue?vue&type=template&id=37f9f8ec&scoped=true&"
import script from "./QueryDeskComponent.vue?vue&type=script&lang=js&"
export * from "./QueryDeskComponent.vue?vue&type=script&lang=js&"
import style0 from "./QueryDeskComponent.vue?vue&type=style&index=0&id=37f9f8ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f9f8ec",
  null
  
)

export default component.exports